import { lazy, Suspense, type ReactNode } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router';

import { LoadingScreen } from '@/components/LoadingScreen';
import { SiteLayout } from '@/layouts/site/SiteLayout';

import { ErrorPage } from './ErrorPage';

const LandingPage = lazy(() =>
  import('@/site/LandingPage').then((m) => ({ default: m.LandingPage })),
);
const LegalPage = lazy(() => import('@/site/LegalPage').then((m) => ({ default: m.LegalPage })));
const NotFoundPage = lazy(() =>
  import('@/site/NotFoundPage').then((m) => ({ default: m.NotFoundPage })),
);

function suspense(node: ReactNode) {
  return <Suspense fallback={<LoadingScreen />}>{node}</Suspense>;
}

const router = createBrowserRouter([
  {
    element: <SiteLayout />,
    errorElement: <ErrorPage />,
    children: [
      { path: '/', element: suspense(<LandingPage />) },
      { path: '/politica-de-privacidade', element: suspense(<LegalPage />) },
      { path: '*', element: suspense(<NotFoundPage />) },
    ],
  },
]);

export function AppRoutes() {
  return <RouterProvider router={router} />;
}
